import {Component, Input, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import {ButtonToggleGroupOption} from '../../models/buttonToggleGroupOption';

@Component({
  selector: 'app-toggle-button-group',
  templateUrl: './buttonToggleGroup.component.html',
  styleUrls: ['./buttonToggleGroup.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonToggleGroupComponent<T> {
  @Input() options: Array<ButtonToggleGroupOption<T>> = [];
  @Input() selectedValue = '';
  @Output() selectedValueChange = new EventEmitter<string>();
  @Output() onChange = new EventEmitter<string>();

  onSelectionChange(value: string) {
    this.selectedValue = value;
    this.selectedValueChange.emit(this.selectedValue);
    this.onChange.emit(this.selectedValue);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/buttonToggleGroup/buttonToggleGroup.component.ts